import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { maybeEmitPermissionErrorFromAxios403 } from "../../utils/permissionAlertEmitter";

const tenantAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Request Interceptor: Tüm isteklerde tenant token'ı otomatik ekler
tenantAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("tokenTenant"); // Tenant token'ı
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Token süresi dolarsa tenant login'e yönlendir
tenantAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("tokenTenant");
      localStorage.removeItem("tenantId");
      localStorage.removeItem("tenantInfo");
      window.location.href = "/corporate-login"; // Tenant login sayfası
    }
    maybeEmitPermissionErrorFromAxios403(error);
    return Promise.reject(error);
  }
);

export default tenantAxiosInstance;


